import React from 'react';
import styled from 'styled-components/macro';
import { Steps } from 'antd';
import { Colors } from '@cognite/cogs.js';

export type Step = {
  key: string;
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  subTitleOnOpen?: React.ReactNode;
  description?: React.ReactNode;
  content: React.ReactNode;
  invalid: boolean;
};

export const DrawerSteps = ({
  steps,
  currentStep = 0,
  onChangeStep,
}: {
  steps: Step[];
  currentStep: number;
  onChangeStep: (step: number) => void;
}) => {
  const stepStatus = (step: number) => {
    if (currentStep > step) {
      return steps[step].invalid ? 'error' : 'finish';
    }
    return currentStep === step ? 'process' : 'wait';
  };

  const stepSubTitle = (item: Step, step: number) => {
    if (currentStep === step && item?.subTitleOnOpen)
      return item?.subTitleOnOpen;
    if (currentStep !== step) return item.subTitle;
    return null;
  };

  return (
    <StyledSteps
      direction="vertical"
      current={currentStep}
      onChange={onChangeStep}
      progressDot={false}
      type="navigation"
    >
      {steps.map((item, i) => (
        <Steps.Step
          key={item.key}
          title={item.title}
          subTitle={stepSubTitle(item, i)}
          icon={false}
          description={
            currentStep === i ? (
              <StepContent>{item.content}</StepContent>
            ) : (
              item?.description
            )
          }
          status={stepStatus(i)}
        />
      ))}
    </StyledSteps>
  );
};

const StyledSteps = styled(Steps)`
  .ant-steps-item:not(.ant-steps-item-active)
    > .ant-steps-item-container[role='button']
    .ant-steps-item-description {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: ${Colors['text-icon--medium']};
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title,
  .ant-steps-item-title {
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    color: var(--cogs-text-primary);
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  }

  .ant-steps-item-container {
    display: flex;
    flex: 1;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  &.ant-steps-vertical > .ant-steps-item {
    border-top: 1px solid ${Colors['border--interactive--default']};
    &:first-child {
      border-top: 0;
    }
    padding: 1rem 0;
    width: 100%;
    display: flex;
    flex: 0 0 auto;
  }

  .ant-steps-item:after,
  .ant-steps-item-icon,
  .ant-steps-item-active:before {
    display: none !important;
  }

  &.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
    overflow: unset !important;
    min-height: 2rem;
    width: 100%;
  }
`;
const StepContent = styled.div`
  display: flex;
  flex: 1;
  padding-bottom: 2rem;
  flex-direction: column;
  gap: 1rem;
  input,
  textarea,
  select {
    max-width: 500px;
  }
  button {
    width: auto;
    margin-right: auto;
  }
`;
